export const addressValidations = [
  { id: "address", required: true, visible: false },
  { id: "city", required: true, visible: false },
  { id: "state", required: true, visible: false },
  { id: "country", required: true, visible: false },
  { id: "zipcode", required: true, visible: false },
];
